import { MasterClass } from '@/@generated/codegen/API';
import createTanstackTableDataStore from '@/ui/TanstackTable/createTanstackTableDataStore';

const useAdminMasterClassTableStore = createTanstackTableDataStore<MasterClass>({
  storeName: 'admin-masterclass-table-store',
  defaultColumnSizing: {},
  defaultColumnVisibility: {
    id: false,
  },
});

export default useAdminMasterClassTableStore;
